import { format, parseISO, differenceInCalendarDays, isValid } from "date-fns";
import { nb } from "date-fns/locale";

export function nok(v, opts = {}) {
  if (v === null || v === undefined || v === "" || Number.isNaN(Number(v))) return "–";
  const n = Number(v);
  const s = new Intl.NumberFormat("nb-NO", { maximumFractionDigits: opts.decimals ?? 0, minimumFractionDigits: opts.decimals ?? 0 }).format(n);
  return opts.bare ? s : `${s} kr`;
}

export function num(v, decimals = 0) {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "–";
  return new Intl.NumberFormat("nb-NO", { maximumFractionDigits: decimals }).format(Number(v));
}

export function pct(v, decimals = 1) {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "–";
  return `${Number(v).toFixed(decimals).replace(".", ",")} %`;
}

export function fmtDate(d, f = "dd.MM.yyyy") {
  if (!d) return "–";
  const dt = typeof d === "string" ? parseISO(d) : d;
  if (!isValid(dt)) return "–";
  return format(dt, f, { locale: nb });
}

export function fmtDateTime(d) {
  return fmtDate(d, "dd.MM.yyyy HH:mm");
}

export function fmtShort(d) {
  return fmtDate(d, "d. MMM");
}

export function relDays(d) {
  if (!d) return "";
  const n = differenceInCalendarDays(parseISO(d), new Date());
  if (n === 0) return "i dag";
  if (n === 1) return "i morgen";
  if (n === -1) return "i går";
  return n > 0 ? `om ${n} d` : `${-n} d siden`;
}

export function todayISO() {
  return format(new Date(), "yyyy-MM-dd");
}

export function addDaysISO(d, n) {
  const dt = typeof d === "string" ? parseISO(d) : d;
  const r = new Date(dt);
  r.setDate(r.getDate() + n);
  return format(r, "yyyy-MM-dd");
}

export function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map((s) => s[0]?.toUpperCase()).join("");
}

export function fileSize(bytes) {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} kB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
